module.exports = __webpack_public_path__ + "static/media/icon_photo.744368a9.svg";